import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import LoaderSpinner from '../LoaderSpinner';
import s from './ElectionResultWrapper.scss';
import ElectionStatusCard from '../../../components/ElectionV2/assembly/ElectionStatusCard/ElectionStatusCard';
import DataBarsWrapper from '../../../components/ElectionV2/common/DataBarsWrapper/DataBarsWrapper';
import DataBar from '../../../components/ElectionV2/common/DataBar/DataBar';
import ElectionBattle from '../../../components/ElectionV2/common/ElectionBattle/ElectionBattle';
import SeatChangeTable from '../../../components/ElectionV2/common/SeatChangeTable/SeatChangeTable';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import { loadResult } from '../../../components/ElectionV2/redux';
import AlliancePopup from '../../../components/ElectionV2/common/AlliancePopup/AlliancePopup';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

class ElectionResultWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    try {
      const { electionData } = props?.sectionData?.items || {};
      const latestData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData)
          .filter(e => e.resultUrl)
          .sort((a, b) => b.year - a.year);
      if (latestData && Array.isArray(latestData) && latestData.length) {
        const { live, source } = latestData[0];
        this.state.currentData = latestData[0];
        this.state.live = live;
        this.state.source = source;
        this.state.selectedYear = Object.values(electionData).sort(
          (a, b) => b.year - a.year,
        )[0].year;
      }
    } catch (error) {
      //
    }
  }

  componentDidMount() {
    if (this.state?.live && this.state?.currentData) {
      setInterval(() => {
        this.props.loadAjaxResultData(
          this.state.currentData.exitPollObject,
          true,
        );
      }, this.props.refreshinterval * 1000);
    }
  }

  setAlliancePopUpData = data => {
    this.setState({
      allianceMap: data,
      showAlliancePopup: !this.state.showAlliancePopup,
    });
    document.body.classList.toggle('disable-scroll');
  };

  toggleAllianceInfoPopup = () => {
    this.setState({ showAlliancePopup: !this.state.showAlliancePopup });
    document.body.classList.toggle('disable-scroll');
  };

  renderElectionstate = () => {
    const {
      hideBattle,
      hideStarCandidate,
      hideLiveblog,
      isWapView,
      hideETheading,
      hideLink,
      wgtclient,
      states = [],
      isExitPoll,
      electionData,
      sortedData,
      starCandidateData,
    } = this.props;

    return (
      <>
        <AdCaller data={{ name: 'exit_first' }} immediateLoad />
        {states &&
          states.length > 1 &&
          states.map(state => (
            <ElectionStatusCard
              key={state.name}
              isExitPoll={isExitPoll}
              config={state}
              data={electionData?.[state.key]}
              sortedData={sortedData && sortedData?.[state.key]}
              isWapView={isWapView}
              setAlliancePopUpData={this.setAlliancePopUpData}
              starCandidateData={false}
              hideStarCandidate={hideStarCandidate}
              hideLiveblog={hideLiveblog}
              hideETheading={hideETheading}
              hideLink={hideLink}
              numberOfStates={states.length}
              hideBattle={hideBattle}
              wgtclient={wgtclient}
              infoMsgClass={state.className}
              noMinHeight
            />
          ))}
        {states &&
          Array.isArray(states) &&
          states.length === 1 &&
          states.map(state => (
            <>
              <ElectionStatusCard
                key={state.name}
                isExitPoll={isExitPoll}
                config={state}
                data={electionData?.[state.key]}
                sortedData={sortedData && sortedData?.[state.key]}
                isWapView={isWapView}
                setAlliancePopUpData={this.setAlliancePopUpData}
                starCandidateData={false}
                hideStarCandidate={hideStarCandidate}
                hideLiveblog={hideLiveblog}
                hideETheading={hideETheading}
                hideLink
                numberOfStates={states.length}
                hideBattle={hideBattle}
                wgtclient={wgtclient}
                infoMsgClass={state.className}
                noMinHeight
              />
              {starCandidateData?.[state.key]?.cnt_rslt &&
                Array.isArray(starCandidateData?.[state.key]?.cnt_rslt) &&
                starCandidateData?.[state.key]?.cnt_rslt.length > 0 && (
                  <div className="slick_UI smallArrow smallArrowBlack">
                    <ElectionBattle
                      isWapView={isWapView}
                      slidesToShow={5}
                      slidesToScroll={5}
                      starCandidateData={starCandidateData[
                        state.key
                      ]?.cnt_rslt.filter(
                        candidate =>
                          candidate.star === true &&
                          candidate.starMeta &&
                          candidate.starMeta.TOI === '1',
                      )}
                      state={state.key}
                      numberOfStates
                      infiniteScroll={false}
                      candidateLinkingAssembly
                      stateName={state.name}
                    />
                  </div>
                )}
              {this.state.currentData.prevYear && (
                <>
                  <div className="mt">
                    <Listingheader
                      headingname={`${this.state.currentData.year} VS ${
                        this.state.currentData.prevYear
                      }`}
                    />
                  </div>
                  {!isWapView && (
                    <div className={s.vsBox}>
                      <div className="boxStyle">
                        <DataBarsWrapper
                          totalSeats={sortedData?.[state.key]?.activeSeats}
                          majority={sortedData?.[state.key]?.majority}
                          exitPoll={isExitPoll}
                          noMinHeight
                          countOfLeadPlusWins={
                            sortedData?.[state.key]?.countOfLeadPlusWins
                          }
                          infoMsg={state?.infoMsg}
                        >
                          {sortedData?.[state.key]?.sortedPartyViewData &&
                            sortedData?.[state.key]?.sortedPartyViewData.map(
                              party => (
                                <DataBar
                                  color={party.cc}
                                  name={party.an}
                                  ws={party.ls + party.ws}
                                  ttl_seat={
                                    sortedData?.[state.key]?.activeSeats
                                  }
                                />
                              ),
                            )}
                        </DataBarsWrapper>
                      </div>
                      <div className="boxStyle">
                        <DataBarsWrapper
                          totalSeats={
                            sortedData?.[state.key]?.lastYearActiveSeats
                          }
                          majority={sortedData?.[state.key]?.lastYearMajority}
                          exitPoll={isExitPoll}
                          noMinHeight
                          countOfLeadPlusWins={{
                            winCount:
                              sortedData?.[state.key]?.lastYearActiveSeats,
                          }}
                        >
                          {sortedData?.[state.key]?.sortedPartyViewData &&
                            sortedData?.[state.key]?.sortedPartyViewData.map(
                              party => (
                                <DataBar
                                  color={party.cc}
                                  name={party.an}
                                  ws={party.pws}
                                  ttl_seat={
                                    sortedData?.[state.key]?.lastYearActiveSeats
                                  }
                                />
                              ),
                            )}
                        </DataBarsWrapper>
                      </div>
                    </div>
                  )}
                  <SeatChangeTable
                    currentYear={this.state.currentData?.year}
                    isWapView={isWapView}
                    lastYear={this.state?.currentData?.prevYear}
                    parties={sortedData?.[state.key]?.sortedPartyViewData}
                    logo
                    leadPlusWinCount={
                      sortedData?.[state.key]?.countOfLeadPlusWins
                    }
                    activeSeats={sortedData?.[state.key]?.activeSeats}
                    leadObject={sortedData?.[state.key]?.leadingPartyObj}
                  />
                </>
              )}
            </>
          ))}

        {isWapView &&
          this.state.showAlliancePopup && (
            <ErrorBoundary>
              <PopupPortal usePopupPortal>
                <AlliancePopup
                  allianceMap={this.state.allianceMap}
                  toggleAllianceInfoPopup={this.toggleAllianceInfoPopup}
                />
              </PopupPortal>
            </ErrorBoundary>
          )}
      </>
    );
  };

  render() {
    const { states = [] } = this.props;

    return (
      <div className={s.resultlWidgetWrapper} ref={this.ref}>
        {this.props.dataLoading && <LoaderSpinner />}
        {this.state?.currentData &&
          this.state?.currentData?.note && (
            <p className={s.noteText}>{this.state?.currentData?.note}</p>
          )}
        <div className="mt">
          {states && states.length > 0 && this.renderElectionstate()}
        </div>
        {this.state?.currentData?.source && (
          <div className={`${s.source} ${s.cl}`}>
            Source: {this.state?.currentData?.source}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.electionV2.refreshinterval,
  electionData: state?.electionV2.electionData,
  starCandidateData: state?.electionV2.starCandidateData,
  isExitPoll: state?.electionV2.isExitPoll,
  displaytext: state?.electionV2.displaytext,
  keywords: state?.electionV2.keywords,
  breakingnews: state?.electionV2.breakingnews,
  states: state?.electionV2.states,
  liveblog: state?.electionV2.liveblog,
  datasource: state?.electionV2.datasource,
  hideexitheading: state?.electionV2.hideexitheading,
  path: state?.electionV2.path,
  exitPollStateData: state?.electionV2.exitPollStateData,
  sortedData: state?.electionV2.sortedData,
  dataLoading: state?.newslisting?.dataLoading,
});

const mapDispatchToProps = dispatch => ({
  loadAjaxResultData: (url, loader = false) => {
    dispatch(loadResult(url, loader));
  },
});

ElectionResultWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  isExitPoll: PropTypes.bool,
  hideETheading: PropTypes.bool,
  dataLoading: PropTypes.bool,
};
ElectionResultWrapper.defaultProps = {
  isWapView: false,
  data: {},
  isExitPoll: false,
  hideETheading: false,
  dataLoading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ElectionResultWrapper,
);
